'use client';
import { useState } from 'react';
import { clsx } from 'clsx';
import { DocumentItem } from '@/components/pages/patients/LegalDocumentsPage/DocumentItem/DocumentItem';
import OpenArrowSvg from '@/assets/icons/open.svg';
import s from './OpeningItem.module.scss';

interface Props {
  title: string;
  text?: string | null;
  file: string | null,
  document_title: string | null,
  file_format: string | null,
}

export const OpeningItem = ({ title, text, file, document_title, file_format }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <li className={s.item} onClick={() => setIsOpen(!isOpen)}>
      <div className={s.item__head}>
        {title}
        <div className={clsx(s.item__arrow, { [s.item__arrow__opened]: isOpen })}>
          <OpenArrowSvg />
        </div>
      </div>
      <div className={clsx(s.item__body, { [s.item__body_opened]: isOpen })}>
        <div className={s.item__bodyInner}>
          <div className={s.item__text} dangerouslySetInnerHTML={{ __html: text || '' }} />
          {file
            && file_format
            && <DocumentItem className={s.item__doc} name={document_title} file={file} format={file_format} />
          }
        </div>
      </div>
    </li>
  );
};